<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    @if (product) {
      <ion-title>
        {{product.title}}
        <p class="subtitle">Variants</p>
      </ion-title>
    }
  </ion-toolbar>

</ion-header>

<ion-content scrollY="false">

  <div class="scroll-wrapper scroll-shadow">

    <div class="variant-wrapper">
      @if (variants) {
        <ion-list>
          @for (variant of variants; track variant) {
            <ion-item detail="true" button="true" (click)="productVariantClicked(variant)" lines="full">
              <ion-label>
                <h3>
                  @for (option of variant.options; track option; let i = $index) {
                    {{option.title}}: {{option.value.title}}@if (i+1 < variant.options.length) {
                    <span> / </span>
                  }
                }
              </h3>
              <ion-grid class="ion-no-padding">
                @if ((variant.sku && show_sku == true) || variant.sell_price || variant.track_stock) {
                  <ion-row>
                    @if (variant.sku && show_sku == true) {
                      <ion-col size="auto">
                        <h5>SKU</h5>
                        <p class="prominent">{{variant.sku}}</p>
                      </ion-col>
                    }
                    @if (variant.sell_price) {
                      <ion-col size="auto">
                        <h5>Price</h5>
                        <p class="prominent">{{cart.currency.sign}}{{variant.sell_price | number:'1.2'}}@if (variant.has_contract_price) {
                          (contract price)
                        }</p>
                      </ion-col>
                    }
                    @if (variant.track_stock) {
                      <ion-col size="auto">
                        <h5>Available</h5>
                        <p class="prominent">
                          @if (variant.available_stock > variant.low_available_stock_level) {
                            <span class="success">{{variant.available_stock}}</span>
                          }
                          @if (variant.available_stock <= variant.low_available_stock_level && variant.available_stock > 0) {
                            <span class="warning">{{variant.available_stock}}</span>
                          }
                          @if (variant.track_stock && variant.available_stock <= 0) {
                            <span class="danger">{{variant.available_stock}}</span>
                          }
                        </p>
                      </ion-col>
                    }
                  </ion-row>
                }
              </ion-grid>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    }
  </div>

  @if (variants && variants.length == 0) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'cube']" size="6x"></fa-icon>
            <span>No variants found</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

  </div>

</ion-content>
